import { makeStyles } from "@material-ui/core";

export const useStylesDark = makeStyles(() => ({
  root: {
    marginTop: "0.5em",
    fontFamily: "Rubik",
  },
  rootInline: {
    display: "inline-flex",
    alignItems: "center",
    verticalAlign: "middle",
    fontFamily: "Rubik",
  },
  rootProminent: {
    marginTop: "0.5em",
    fontFamily: "Rubik",
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  openButton: {
    color: "rgb(190, 190, 190)",
    textTransform: "none",
    margin: "0.35em 0 0",
    width: "50%",
    fontSize: "0.72em",
    fontWeight: 400,
    padding: "0.4em 0.5em",
    minHeight: "unset",
    lineHeight: 1.35,
    border: "none",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#313131",
    },
  },
  openButtonProminent: {
    color: "white",
    textTransform: "none",
    margin: "0.35em 0 0",
    width: "60%",
    fontSize: "0.85em",
    fontWeight: 600,
    padding: "0.55em 1em",
    minHeight: "unset",
    lineHeight: 1.35,
    border: "none",
    borderRadius: "6px",
    background: "linear-gradient(45deg, #3a80c0 30%, #2c6fad 90%)",
    boxShadow: "0 2px 8px rgba(93, 139, 208, 0.35)",
    "&:hover": {
      background: "linear-gradient(45deg, #4a90d0 30%, #3a80c0 90%)",
    },
  },
  dialogPaper: {
    backgroundColor: "rgb(34 36 38)",
    fontFamily: "Rubik",
    borderRadius: "8px",
  },
  dialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0.75em 1em 0.5em",
  },
  dialogTitleText: {
    color: "rgb(206 205 203)",
    fontSize: "0.9em",
    fontWeight: 500,
  },
  closeButton: {
    color: "rgb(150 150 150)",
    padding: "0.35em",
  },
  dialogContent: {
    padding: "0 1em 1em",
    color: "rgb(150 150 150)",
  },
  disclaimerText: {
    color: "rgb(150 150 150)",
    fontSize: "0.9em",
    lineHeight: 1.55,
    marginBottom: 0,
  },
  disclaimerTitle: {
    color: "rgb(206 205 203)",
    fontSize: "0.95em",
    fontWeight: 600,
    marginBottom: "0.5em",
    lineHeight: 1.4,
  },
  disclaimerBlock: {
    marginBottom: "1em",
  },
  disclaimerProminent: {
    backgroundColor: "rgba(93, 139, 208, 0.1)",
    border: "1px solid rgba(93, 139, 208, 0.35)",
    borderRadius: "6px",
    padding: "0.85em 1em",
    marginBottom: "1em",
  },
  disclaimerTextProminent: {
    color: "rgb(180 210 255)",
    fontSize: "0.92em",
    lineHeight: 1.55,
    marginBottom: 0,
  },
  disclaimerActions: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "0.75em",
  },
  setupFlow: {
    display: "flex",
    flexDirection: "column",
    gap: "0.25em",
  },
  setupStep: {
    display: "flex",
    gap: "0.75em",
    alignItems: "flex-start",
    padding: "0.85em 0",
    borderBottom: "1px solid rgba(128, 128, 128, 0.15)",
    "&:last-child": {
      borderBottom: "none",
      paddingBottom: 0,
    },
  },
  setupStepNumber: {
    flexShrink: 0,
    width: "1.65em",
    height: "1.65em",
    borderRadius: "50%",
    backgroundColor: "rgba(93, 139, 208, 0.25)",
    color: "rgb(180 210 255)",
    fontSize: "0.85em",
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: 1,
  },
  setupStepContent: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  setupStepTitle: {
    color: "rgb(206 205 203)",
    fontSize: "0.9em",
    fontWeight: 600,
    marginBottom: "0.35em",
    lineHeight: 1.35,
  },
  setupStepBody: {
    color: "rgb(150 150 150)",
    fontSize: "0.82em",
    lineHeight: 1.5,
    marginBottom: "0.65em",
  },
  setupStepButton: {
    marginTop: 0,
  },
  convexDelegateCheckbox: {
    marginLeft: 0,
    marginBottom: "0.55em",
    alignItems: "flex-start",
    "& .MuiTypography-root": {
      color: "rgb(170 170 168)",
      fontSize: "0.8em",
      lineHeight: 1.4,
      paddingTop: "0.15em",
    },
    "& .MuiCheckbox-root": {
      padding: "0 0.35em 0 0",
      color: "rgb(140 140 140)",
    },
    "& .Mui-checked": {
      color: "#5d8bd0",
    },
  },
  convexDelegateLabel: {
    display: "inline-flex",
    alignItems: "center",
    gap: "0.3em",
  },
  convexDelegateInfoIcon: {
    fontSize: "0.95em",
    color: "rgb(140 140 140)",
    cursor: "help",
    verticalAlign: "middle",
  },
  setupStepNumberComplete: {
    backgroundColor: "rgba(76, 175, 80, 0.25)",
    color: "rgb(160 220 160)",
  },
  setupStepComplete: {
    color: "rgb(140 200 140)",
    fontSize: "0.82em",
    fontWeight: 500,
  },
  inlineOptimizedBlock: {
    maxWidth: "32em",
    margin: "0 auto 1em",
    padding: "0 1em",
    textAlign: "center",
  },
  delegateButton: {
    background: "linear-gradient(45deg, #2c6fad 30%, #1a4f8a 90%)",
    color: "white",
    textTransform: "none",
    padding: "0.5em 1.25em",
    borderRadius: "6px",
    fontSize: "0.85em",
    fontWeight: 500,
    "&:hover": {
      background: "linear-gradient(45deg, #3a80c0 30%, #2460a0 90%)",
    },
    "&:disabled": {
      background: "rgba(100, 100, 100, 0.3)",
      color: "rgba(206, 205, 203, 0.4)",
    },
  },
  delegateButtonProminent: {
    background: "linear-gradient(45deg, #3a80c0 30%, #2c6fad 90%)",
    color: "white",
    textTransform: "none",
    padding: "0.65em 1.5em",
    borderRadius: "6px",
    fontSize: "0.92em",
    fontWeight: 600,
    boxShadow: "0 2px 8px rgba(93, 139, 208, 0.35)",
    "&:hover": {
      background: "linear-gradient(45deg, #4a90d0 30%, #3a80c0 90%)",
    },
    "&:disabled": {
      background: "rgba(100, 100, 100, 0.3)",
      color: "rgba(206, 205, 203, 0.4)",
      boxShadow: "none",
    },
  },
  unionButton: {
    background: "linear-gradient(45deg, #2c6fad 30%, #1a4f8a 90%)",
    color: "white",
    textTransform: "none",
    padding: "0.5em 1.25em",
    borderRadius: "6px",
    fontSize: "0.85em",
    fontWeight: 500,
    "&:hover": {
      background: "linear-gradient(45deg, #3a80c0 30%, #2460a0 90%)",
    },
  },
  proceedButton: {
    background: "transparent",
    color: "rgb(190, 190, 190)",
    textTransform: "none",
    padding: "0.4em 0.75em",
    borderRadius: "4px",
    border: "1px solid grey",
    fontSize: "0.82em",
    fontWeight: 400,
    marginTop: "0.5em",
    "&:hover": {
      backgroundColor: "#313131",
    },
  },
  warningBox: {
    backgroundColor: "rgba(128, 128, 128, 0.08)",
    border: "1px solid rgba(128, 128, 128, 0.2)",
    borderRadius: "4px",
    padding: "0.6em 0.75em",
    marginBottom: "0.75em",
    color: "rgb(150 150 150)",
    fontSize: "0.82em",
    lineHeight: 1.45,
  },
  sectionLabel: {
    color: "rgb(120 120 120)",
    fontSize: "0.78em",
    marginBottom: "0.4em",
    marginTop: "0.75em",
  },
  tokenGrid: {
    display: "flex",
    flexWrap: "wrap",
    gap: "0.35em",
    marginBottom: "0.75em",
  },
  tokenChip: {
    display: "flex",
    alignItems: "center",
    gap: "0.35em",
    padding: "0.2em 0.55em",
    borderRadius: "12px",
    border: "1px solid rgba(128, 128, 128, 0.35)",
    cursor: "pointer",
    backgroundColor: "transparent",
    color: "rgb(150 150 150)",
    fontSize: "0.78em",
    fontFamily: "inherit",
    transition: "border-color 0.15s, color 0.15s",
    "&:hover": {
      borderColor: "rgba(190, 190, 190, 0.5)",
      color: "rgb(190, 190, 190)",
    },
  },
  tokenChipSelected: {
    borderColor: "rgb(93 139 208)",
    backgroundColor: "rgba(93, 139, 208, 0.22)",
    color: "rgb(180 210 255)",
    "&:hover": {
      borderColor: "rgb(120 165 230)",
      backgroundColor: "rgba(93, 139, 208, 0.3)",
      color: "rgb(200 220 255)",
    },
  },
  divider: {
    borderColor: "rgba(128, 128, 128, 0.15)",
    margin: "0.75em 0",
  },
  allocationTable: {
    width: "100%",
    borderCollapse: "collapse",
    fontFamily: "inherit",
  },
  tableHead: {
    color: "rgb(120 120 120)",
    fontSize: "0.75em",
    paddingBottom: "0.35em",
    borderBottom: "1px solid rgba(128, 128, 128, 0.15)",
    fontFamily: "inherit",
    fontWeight: 400,
  },
  tableRow: {
    borderBottom: "1px solid rgba(128, 128, 128, 0.08)",
  },
  tableCell: {
    color: "rgb(150 150 150)",
    fontSize: "0.82em",
    padding: "0.35em 0.2em",
    verticalAlign: "middle",
    fontFamily: "inherit",
  },
  allocationBar: {
    height: "4px",
    borderRadius: "2px",
    backgroundColor: "rgba(190, 190, 190, 0.5)",
    display: "inline-block",
    marginRight: "0.4em",
    verticalAlign: "middle",
  },
  pctText: {
    color: "rgb(150 150 150)",
    fontWeight: 500,
    minWidth: "3em",
    display: "inline-block",
    fontSize: "0.82em",
  },
  emptyText: {
    color: "rgb(120 120 120)",
    fontSize: "0.82em",
    padding: "0.5em 0",
  },
  submitActions: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "0.75em",
  },
  submitButton: {
    background: "transparent",
    color: "rgb(190, 190, 190)",
    textTransform: "none",
    padding: "0.35em 0.75em",
    borderRadius: "4px",
    border: "1px solid grey",
    fontSize: "0.82em",
    fontWeight: 400,
    "&:hover": {
      backgroundColor: "#313131",
    },
    "&:disabled": {
      borderColor: "rgba(128, 128, 128, 0.3)",
      color: "rgba(128, 128, 128, 0.5)",
    },
  },
  statusText: {
    marginTop: "0.5em",
    fontSize: "0.82em",
    textAlign: "center",
  },
  statusSuccess: {
    color: "rgb(120 180 130)",
  },
  statusError: {
    color: "rgb(180 100 100)",
  },
  noTokensText: {
    color: "rgb(120 120 120)",
    fontSize: "0.82em",
  },
}));

export const useStylesLight = makeStyles(() => ({
  root: {
    marginTop: "0.5em",
    fontFamily: "Rubik",
  },
  rootInline: {
    display: "inline-flex",
    alignItems: "center",
    verticalAlign: "middle",
    fontFamily: "Rubik",
  },
  rootProminent: {
    marginTop: "0.5em",
    fontFamily: "Rubik",
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  openButton: {
    color: "grey",
    textTransform: "none",
    margin: "0.35em 0 0",
    width: "50%",
    fontSize: "0.72em",
    fontWeight: 400,
    padding: "0.4em 0.5em",
    minHeight: "unset",
    lineHeight: 1.35,
    border: "none",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },
  openButtonProminent: {
    color: "white",
    textTransform: "none",
    margin: "0.35em 0 0",
    width: "60%",
    fontSize: "0.85em",
    fontWeight: 600,
    padding: "0.55em 1em",
    minHeight: "unset",
    lineHeight: 1.35,
    border: "none",
    borderRadius: "6px",
    background: "linear-gradient(45deg, #3a80c0 30%, #2c6fad 90%)",
    boxShadow: "0 2px 8px rgba(44, 111, 173, 0.25)",
    "&:hover": {
      background: "linear-gradient(45deg, #4a90d0 30%, #3a80c0 90%)",
    },
  },
  dialogPaper: {
    backgroundColor: "#f5f5f5",
    fontFamily: "Rubik",
    borderRadius: "8px",
  },
  dialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0.75em 1em 0.5em",
  },
  dialogTitleText: {
    color: "#1a1a1a",
    fontSize: "0.9em",
    fontWeight: 500,
  },
  closeButton: {
    color: "#888",
    padding: "0.35em",
  },
  dialogContent: {
    padding: "0 1em 1em",
    color: "#555",
  },
  disclaimerText: {
    color: "#555",
    fontSize: "0.9em",
    lineHeight: 1.55,
    marginBottom: 0,
  },
  disclaimerTitle: {
    color: "#1a1a1a",
    fontSize: "0.95em",
    fontWeight: 600,
    marginBottom: "0.5em",
    lineHeight: 1.4,
  },
  disclaimerBlock: {
    marginBottom: "1em",
  },
  disclaimerProminent: {
    backgroundColor: "rgba(44, 111, 173, 0.08)",
    border: "1px solid rgba(44, 111, 173, 0.35)",
    borderRadius: "6px",
    padding: "0.85em 1em",
    marginBottom: "1em",
  },
  disclaimerTextProminent: {
    color: "#2c5f8a",
    fontSize: "0.92em",
    lineHeight: 1.55,
    marginBottom: 0,
  },
  disclaimerActions: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "0.75em",
  },
  setupFlow: {
    display: "flex",
    flexDirection: "column",
    gap: "0.25em",
  },
  setupStep: {
    display: "flex",
    gap: "0.75em",
    alignItems: "flex-start",
    padding: "0.85em 0",
    borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
    "&:last-child": {
      borderBottom: "none",
      paddingBottom: 0,
    },
  },
  setupStepNumber: {
    flexShrink: 0,
    width: "1.65em",
    height: "1.65em",
    borderRadius: "50%",
    backgroundColor: "rgba(44, 111, 173, 0.15)",
    color: "#2c5f8a",
    fontSize: "0.85em",
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: 1,
  },
  setupStepContent: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  setupStepTitle: {
    color: "#1a1a1a",
    fontSize: "0.9em",
    fontWeight: 600,
    marginBottom: "0.35em",
    lineHeight: 1.35,
  },
  setupStepBody: {
    color: "#666",
    fontSize: "0.82em",
    lineHeight: 1.5,
    marginBottom: "0.65em",
  },
  setupStepButton: {
    marginTop: 0,
  },
  convexDelegateCheckbox: {
    marginLeft: 0,
    marginBottom: "0.55em",
    alignItems: "flex-start",
    "& .MuiTypography-root": {
      color: "#555",
      fontSize: "0.8em",
      lineHeight: 1.4,
      paddingTop: "0.15em",
    },
    "& .MuiCheckbox-root": {
      padding: "0 0.35em 0 0",
      color: "#999",
    },
    "& .Mui-checked": {
      color: "#2c6fad",
    },
  },
  convexDelegateLabel: {
    display: "inline-flex",
    alignItems: "center",
    gap: "0.3em",
  },
  convexDelegateInfoIcon: {
    fontSize: "0.95em",
    color: "#888",
    cursor: "help",
    verticalAlign: "middle",
  },
  setupStepNumberComplete: {
    backgroundColor: "rgba(76, 175, 80, 0.25)",
    color: "rgb(160 220 160)",
  },
  setupStepComplete: {
    color: "rgb(140 200 140)",
    fontSize: "0.82em",
    fontWeight: 500,
  },
  inlineOptimizedBlock: {
    maxWidth: "32em",
    margin: "0 auto 1em",
    padding: "0 1em",
    textAlign: "center",
  },
  delegateButton: {
    background: "linear-gradient(45deg, #2c6fad 30%, #1a4f8a 90%)",
    color: "white",
    textTransform: "none",
    padding: "0.5em 1.25em",
    borderRadius: "6px",
    fontSize: "0.85em",
    fontWeight: 500,
    "&:hover": {
      background: "linear-gradient(45deg, #3a80c0 30%, #2460a0 90%)",
    },
    "&:disabled": {
      background: "rgba(180, 180, 180, 0.4)",
      color: "rgba(0, 0, 0, 0.3)",
    },
  },
  delegateButtonProminent: {
    background: "linear-gradient(45deg, #3a80c0 30%, #2c6fad 90%)",
    color: "white",
    textTransform: "none",
    padding: "0.65em 1.5em",
    borderRadius: "6px",
    fontSize: "0.92em",
    fontWeight: 600,
    boxShadow: "0 2px 8px rgba(44, 111, 173, 0.25)",
    "&:hover": {
      background: "linear-gradient(45deg, #4a90d0 30%, #3a80c0 90%)",
    },
    "&:disabled": {
      background: "rgba(180, 180, 180, 0.4)",
      color: "rgba(0, 0, 0, 0.3)",
      boxShadow: "none",
    },
  },
  unionButton: {
    background: "linear-gradient(45deg, #2c6fad 30%, #1a4f8a 90%)",
    color: "white",
    textTransform: "none",
    padding: "0.5em 1.25em",
    borderRadius: "6px",
    fontSize: "0.85em",
    fontWeight: 500,
    "&:hover": {
      background: "linear-gradient(45deg, #3a80c0 30%, #2460a0 90%)",
    },
  },
  proceedButton: {
    background: "transparent",
    color: "grey",
    textTransform: "none",
    padding: "0.4em 0.75em",
    borderRadius: "4px",
    border: "1px solid grey",
    fontSize: "0.82em",
    fontWeight: 400,
    marginTop: "0.5em",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },
  warningBox: {
    backgroundColor: "rgba(0, 0, 0, 0.03)",
    border: "1px solid rgba(0, 0, 0, 0.08)",
    borderRadius: "4px",
    padding: "0.6em 0.75em",
    marginBottom: "0.75em",
    color: "#666",
    fontSize: "0.82em",
    lineHeight: 1.45,
  },
  sectionLabel: {
    color: "#888",
    fontSize: "0.78em",
    marginBottom: "0.4em",
    marginTop: "0.75em",
  },
  tokenGrid: {
    display: "flex",
    flexWrap: "wrap",
    gap: "0.35em",
    marginBottom: "0.75em",
  },
  tokenChip: {
    display: "flex",
    alignItems: "center",
    gap: "0.35em",
    padding: "0.2em 0.55em",
    borderRadius: "12px",
    border: "1px solid rgba(0, 0, 0, 0.15)",
    cursor: "pointer",
    backgroundColor: "transparent",
    color: "#777",
    fontSize: "0.78em",
    fontFamily: "inherit",
    transition: "border-color 0.15s, color 0.15s",
    "&:hover": {
      borderColor: "rgba(0, 0, 0, 0.3)",
      color: "#555",
    },
  },
  tokenChipSelected: {
    borderColor: "#2c6fad",
    backgroundColor: "rgba(44, 111, 173, 0.15)",
    color: "#1a4f8a",
    "&:hover": {
      borderColor: "#3a80c0",
      backgroundColor: "rgba(44, 111, 173, 0.22)",
      color: "#1a4f8a",
    },
  },
  divider: {
    borderColor: "rgba(0, 0, 0, 0.08)",
    margin: "0.75em 0",
  },
  allocationTable: {
    width: "100%",
    borderCollapse: "collapse",
    fontFamily: "inherit",
  },
  tableHead: {
    color: "#888",
    fontSize: "0.75em",
    paddingBottom: "0.35em",
    borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
    fontFamily: "inherit",
    fontWeight: 400,
  },
  tableRow: {
    borderBottom: "1px solid rgba(0, 0, 0, 0.05)",
  },
  tableCell: {
    color: "#555",
    fontSize: "0.82em",
    padding: "0.35em 0.2em",
    verticalAlign: "middle",
    fontFamily: "inherit",
  },
  allocationBar: {
    height: "4px",
    borderRadius: "2px",
    backgroundColor: "rgba(0, 0, 0, 0.2)",
    display: "inline-block",
    marginRight: "0.4em",
    verticalAlign: "middle",
  },
  pctText: {
    color: "#555",
    fontWeight: 500,
    minWidth: "3em",
    display: "inline-block",
    fontSize: "0.82em",
  },
  emptyText: {
    color: "#aaa",
    fontSize: "0.82em",
    padding: "0.5em 0",
  },
  submitActions: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "0.75em",
  },
  submitButton: {
    background: "transparent",
    color: "grey",
    textTransform: "none",
    padding: "0.35em 0.75em",
    borderRadius: "4px",
    border: "1px solid grey",
    fontSize: "0.82em",
    fontWeight: 400,
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
    "&:disabled": {
      borderColor: "rgba(0, 0, 0, 0.12)",
      color: "rgba(0, 0, 0, 0.3)",
    },
  },
  statusText: {
    marginTop: "0.5em",
    fontSize: "0.82em",
    textAlign: "center",
  },
  statusSuccess: {
    color: "#2e7d32",
  },
  statusError: {
    color: "#c62828",
  },
  noTokensText: {
    color: "#888",
    fontSize: "0.82em",
  },
}));
